import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import back from "./images/backk.png";
import swichh from "./images/switchh.png";
import icon from "./images/ROSAFNewunscreen.gif";

const formatDateTime = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

function Opens() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [usingBackCamera, setUsingBackCamera] = useState(false);
  const [sendingFrames, setSendingFrames] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [popupAction, setPopupAction] = useState(null);
  const [result, setResult] = useState("");
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem("userEmail");

  useEffect(() => {
    const getMediaStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: usingBackCamera ? "environment" : "user" },
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error("Error accessing the camera: ", err);
      }
    };

    getMediaStream();

    return () => {
      if (videoRef.current?.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, [usingBackCamera]);

  const handleSwitchCamera = () => {
    setUsingBackCamera((prev) => !prev);
  };

  const checkLastTimestamps = async (personName, currentDateTime) => {
    try {
      const response = await fetch("https://www.d-rosa.ai/CHECKTIMEAPI", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userEmail, personName }),
      });

      const data = await response.json();
      const currentTime = new Date(currentDateTime).getTime();

      const lastInTime = data.lastInTime ? new Date(data.lastInTime).getTime() : null;
      const lastOutTime = data.lastOutTime ? new Date(data.lastOutTime).getTime() : null;

      console.log("Last In Time:", data.lastInTime);
      console.log("Last Out Time:", data.lastOutTime);
      console.log("Current Time:", currentDateTime);

      if (lastInTime && (currentTime - lastInTime) / 60000 < 5) {
        setResult("Login ignored (within 5-minute rule).");
        return;
      }
      if (lastOutTime && (currentTime - lastOutTime) / 60000 < 5) {
        setResult("Logout ignored (within 5-minute rule).");
        return;
      }

      setDialogMessage(`Detected ${personName}. Do you want to log time?`);
      setPopupAction(() => () => logTime(personName, currentDateTime));
      setShowPopup(true);
    } catch (error) {
      console.error("Error checking timestamps:", error);
    }
  };

  const sendFrameToServer = async () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const video = videoRef.current;

    context.drawImage(video, 0, 0, 480, 360);
    const frameData = canvas.toDataURL("image/jpeg").split(",")[1];
    const currentDateTime = formatDateTime(new Date());

    try {
      const res = await fetch("https://www.d-rosa.ai/FACERECGAPI", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ frame: frameData, userEmail, currentDateTime }),
      });

      const data = await res.json();
      setResult(data.message);

      if (data.message.includes("Matched")) {
        const personName = data.message.split("Matched ")[1].trim();
        await checkLastTimestamps(personName, currentDateTime);
      }
    } catch (error) {
      console.error("Error sending frame:", error);
    }
  };

  const logTime = async (personName, currentDateTime) => {
    try {
      const res = await fetch("https://www.d-rosa.ai/LOGTIMEAPI", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userEmail, personName, currentDateTime }),
      });

      const response = await res.json();
      alert(response.message);
      setShowPopup(false);
    } catch (error) {
      console.error("Error logging time:", error);
    }
  };

  useEffect(() => {
    let intervalId;
    if (sendingFrames) {
      intervalId = setInterval(sendFrameToServer, 2000);
    }
    return () => clearInterval(intervalId);
  }, [sendingFrames]);

  if (!userEmail) {
    navigate("/signin");
    return null;
  }

  return (
    <div
      id="image-container"
      style={{
        background: "linear-gradient(to bottom, #fff7ad, #ffa9f9)",
        minHeight: "100vh",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img src={icon} alt="Logo" width="150" height="140" />
      <h2 style={{ color: "#E11584" }}>Open Screen</h2>
      <p>Signed in as: {userEmail}</p>

      <video
        ref={videoRef}
        autoPlay
        style={{
          maxWidth: "100%",
          border: "2px solid black",
          width: "480px",
          height: "360px",
        }}
      />
      <canvas
        ref={canvasRef}
        width="480"
        height="360"
        style={{ display: "none" }}
      />

      <div style={{ marginTop: "10px" }}>
        <button onClick={handleSwitchCamera} style={{ border: "none", background: "transparent" }}>
          <img src={swichh} alt="Switch Camera" width="50" height="50" />
        </button>
      </div>

      <div style={{ marginTop: "20px" }}>
        <button
          onClick={() => setSendingFrames(true)}
          style={{
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            padding: "10px 20px",
            cursor: "pointer",
            margin: "5px",
          }}
        >
          Start
        </button>
        <button
          onClick={() => setSendingFrames(false)}
          style={{
            backgroundColor: "#dc3545",
            color: "white",
            border: "none",
            padding: "10px 20px",
            cursor: "pointer",
            margin: "5px",
          }}
        >
          Stop
        </button>
      </div>

      <p>{result}</p>

      <button onClick={() => navigate(-1)} style={{ border: "none", background: "transparent" }}>
        <img src={back} alt="Back" width="50" height="50" />
      </button>

      {showPopup && (
        <div className="dialog">
          <p>{dialogMessage}</p>
          <button onClick={popupAction}>Ok</button>
          <button onClick={() => setShowPopup(false)}>Cancel</button>
        </div>
      )}
    </div>
  );
}

export default Opens;
